import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex mx-lg-n4 py-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "col-12 offset-lg-1 col-lg-10 row g-0" }
const _hoisted_4 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-first-name" }, [
  /*#__PURE__*/_createTextVNode(" First Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_8 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-last-name" }, [
  /*#__PURE__*/_createTextVNode(" Last Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_12 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "date-of-birth",
  id: "Referral_Date_Of_Birth_Label"
}, " Date of Birth ", -1 /* HOISTED */)
const _hoisted_14 = { class: "input-group date datepickerInput" }
const _hoisted_15 = ["value", "on-change"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_17 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-role" }, " Role ", -1 /* HOISTED */)
const _hoisted_19 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-relationship" }, [
  /*#__PURE__*/_createTextVNode(" Relationship "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Relationship", -1 /* HOISTED */)
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_25 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  id: "gender_Label",
  for: "gender"
}, " Gender ", -1 /* HOISTED */)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Gender", -1 /* HOISTED */)
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 0,
  class: "form-group col-12 col-lg-4"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-rel-desc" }, " Relationship Description ", -1 /* HOISTED */)
const _hoisted_31 = ["disabled"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_33 = { class: "col-12 form-group d-flex" }
const _hoisted_34 = { class: "form-check custom-checkbox form-check-inline mt-2" }
const _hoisted_35 = ["id", "disabled"]
const _hoisted_36 = ["for"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Same as Patient Primary Address", -1 /* HOISTED */)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "col-12 offset-lg-1 col-lg-10 row g-0" }
const _hoisted_40 = { class: "col-12 col-lg-8" }
const _hoisted_41 = { class: "col-12 offset-lg-1 col-lg-10 row g-0" }
const _hoisted_42 = { class: "form-group col-12 col-lg-5 pe-lg-2" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-primary-number" }, " Primary Phone ", -1 /* HOISTED */)
const _hoisted_44 = { class: "form-group col-12 col-lg-5 pe-lg-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-alternate-number" }, " Alternate Phone ", -1 /* HOISTED */)
const _hoisted_46 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_47 = { for: "auth-contact-email" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Email ")
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { for: "referral-race" }, " Race ", -1 /* HOISTED */)
const _hoisted_54 = { class: "form-check custom-checkbox pt-1 ms-1" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "decline-race"
}, "Declines to Specify", -1 /* HOISTED */)
const _hoisted_56 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { for: "referral-ethnicity" }, " Ethnicity ", -1 /* HOISTED */)
const _hoisted_58 = ["disabled"]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select Ethnicity", -1 /* HOISTED */)
const _hoisted_60 = ["value"]
const _hoisted_61 = { class: "form-check custom-checkbox pt-1 ms-1" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "decline-ethnicity"
}, "Declines to Specify", -1 /* HOISTED */)
const _hoisted_63 = { class: "col-12 form-group d-flex flex-wrap" }
const _hoisted_64 = { class: "form-check custom-checkbox form-check-inline" }
const _hoisted_65 = ["id", "disabled"]
const _hoisted_66 = ["for"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, " Emergency Contact ", -1 /* HOISTED */)
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = { class: "form-check custom-checkbox form-check-inline" }
const _hoisted_70 = ["id", "disabled"]
const _hoisted_71 = ["for"]
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, " Bereavement Contact ", -1 /* HOISTED */)
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = { class: "form-check custom-checkbox form-check-inline" }
const _hoisted_75 = ["id", "disabled"]
const _hoisted_76 = ["for"]
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, " Grant Family Portal Access ", -1 /* HOISTED */)
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = {
  key: 1,
  class: "p-5 w-100 d-flex flex-column text-center text-primary"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "big-text mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Save Contact In Progress...")
], -1 /* HOISTED */)
const _hoisted_82 = [
  _hoisted_80,
  _hoisted_81
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TagsInput = _resolveComponent("TagsInput")!
  const _component_AddressForm = _resolveComponent("AddressForm")!
  const _component_PhoneNumber = _resolveComponent("PhoneNumber")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_number_only = _resolveDirective("number-only")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    "application-id": _ctx.contact.application,
    showBackground: false
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("section", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _withDirectives(_createElementVNode("input", {
                    name: "auth-contact-first-name",
                    class: _normalizeClass(["form-control", `${!_ctx.v$.contact.firstName.$error ? '' : 'field-invalid'}`]),
                    maxlength: "50",
                    type: "text",
                    placeholder: "Enter First Name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contact.firstName) = $event)),
                    disabled: !_ctx.isEditable,
                    onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.contact.firstName.$touch && _ctx.v$.contact.firstName.$touch(...args)))
                  }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_6), [
                    [_vModelText, _ctx.contact.firstName]
                  ]),
                  (_ctx.v$.contact.firstName.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "First Name is required."))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    name: "auth-contact-last-name",
                    class: _normalizeClass(["form-control", `${!_ctx.v$.contact.lastName.$error ? '' : 'field-invalid'}`]),
                    maxlength: "50",
                    type: "text",
                    placeholder: "Enter Last Name",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contact.lastName) = $event)),
                    disabled: !_ctx.isEditable,
                    onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.contact.lastName.$touch && _ctx.v$.contact.lastName.$touch(...args)))
                  }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_10), [
                    [_vModelText, _ctx.contact.lastName]
                  ]),
                  (_ctx.v$.contact.lastName.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Last Name is required."))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_DatePicker, { getDate: _ctx.getDate }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("input", {
                          name: "dateOfBirth",
                          id: "Referral_Date_Of_Birth",
                          type: "text",
                          class: "form-control",
                          placeholder: "MM/DD/YYYY",
                          value: _ctx.formatDateInput(_ctx.contact.dateOfBirth),
                          "on-change": (e) => _ctx.getDate(e.target.value, e.target.name),
                          autocomplete: "off"
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_15),
                        _hoisted_16
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["getDate"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_TagsInput, {
                    data: _ctx.contactRolesEnum,
                    tags: _ctx.selectedContactRoles,
                    placeholder: "Start Typing...",
                    "open-on-focus": true,
                    disabled: !_ctx.isEditable,
                    onUpdateTags: _ctx.selectedContactRolesUpdated
                  }, null, 8 /* PROPS */, ["data", "tags", "disabled", "onUpdateTags"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["form-select", `${!_ctx.v$.contact.relationship.$error ? '' : 'field-invalid'}`]),
                    name: "relationship",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contact.relationship) = $event)),
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleRelationshipSelection())),
                    disabled: !_ctx.isEditable,
                    onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.v$.contact.relationship.$touch && _ctx.v$.contact.relationship.$touch(...args)))
                  }, [
                    _hoisted_22,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relationshipsEnum, (relationship) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: relationship.id,
                        value: relationship.value
                      }, _toDisplayString(relationship.name), 9 /* TEXT, PROPS */, _hoisted_23))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_21), [
                    [_vModelSelect, _ctx.contact.relationship]
                  ]),
                  (_ctx.v$.contact.relationship.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Relationship is required."))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _withDirectives(_createElementVNode("select", {
                    id: "gender",
                    class: "form-select",
                    name: "gender",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contact.gender) = $event))
                  }, [
                    _hoisted_27,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Genders, (value) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: value.value,
                        key: value.name
                      }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_28))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.contact.gender]
                  ])
                ]),
                (_ctx.showRelationshipDescription)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _hoisted_30,
                      _withDirectives(_createElementVNode("input", {
                        name: "auth-contact-rel-desc",
                        class: "form-control",
                        type: "text",
                        placeholder: "Enter Relationship Description",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.contact.otherRelationshipDescription) = $event)),
                        disabled: !_ctx.isEditable
                      }, null, 8 /* PROPS */, _hoisted_31), [
                        [_vModelText, _ctx.contact.otherRelationshipDescription]
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: `same-patient-addr-${_ctx.contact.contactOrder}`,
                      class: "form-check-input au-target",
                      disabled: !_ctx.isEditable,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.addrSameAsPatientAddr) = $event))
                    }, null, 8 /* PROPS */, _hoisted_35), [
                      [_vModelCheckbox, _ctx.addrSameAsPatientAddr]
                    ]),
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: `same-patient-addr-${_ctx.contact.contactOrder}`
                    }, _hoisted_38, 8 /* PROPS */, _hoisted_36)
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_AddressForm, {
                    address: _ctx.contact.address,
                    updateAddress: _ctx.updateAddress,
                    "disable-inputs": _ctx.addrSameAsPatientAddr || !_ctx.isEditable
                  }, null, 8 /* PROPS */, ["address", "updateAddress", "disable-inputs"])
                ])
              ]),
              _createElementVNode("section", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _withDirectives(_createVNode(_component_PhoneNumber, {
                    name: "primaryPhoneNumber",
                    "enable-country": true,
                    "phone-type-options": _ctx.phoneNumberOptions,
                    value: _ctx.contact.phoneNumbers[_ctx.primaryNumberIndex(_ctx.contact.phoneNumbers)].number,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.contact.phoneNumbers[_ctx.primaryNumberIndex(_ctx.contact.phoneNumbers)].number) = $event)),
                    extension: 
                                    _ctx.contact.phoneNumbers[_ctx.primaryNumberIndex(_ctx.contact.phoneNumbers)].extension
                                ,
                    "onUpdate:extension": _cache[11] || (_cache[11] = ($event: any) => ((
                                    _ctx.contact.phoneNumbers[_ctx.primaryNumberIndex(_ctx.contact.phoneNumbers)].extension
                                ) = $event)),
                    type: _ctx.primaryType,
                    "onUpdate:type": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.primaryType) = $event)),
                    country: _ctx.contact.phoneNumbers[_ctx.primaryNumberIndex(_ctx.contact.phoneNumbers)].country,
                    "onUpdate:country": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.contact.phoneNumbers[_ctx.primaryNumberIndex(_ctx.contact.phoneNumbers)].country) = $event)),
                    disabled: !_ctx.isEditable
                  }, null, 8 /* PROPS */, ["phone-type-options", "value", "extension", "type", "country", "disabled"]), [
                    [_directive_number_only]
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _withDirectives(_createVNode(_component_PhoneNumber, {
                    name: "alternatePhoneNumber",
                    "enable-country": true,
                    "phone-type-options": _ctx.phoneNumberOptions,
                    value: 
                                    _ctx.contact.phoneNumbers[_ctx.alternativeNumberIndex(_ctx.contact.phoneNumbers)].number
                                ,
                    "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((
                                    _ctx.contact.phoneNumbers[_ctx.alternativeNumberIndex(_ctx.contact.phoneNumbers)].number
                                ) = $event)),
                    extension: 
                                    _ctx.contact.phoneNumbers[_ctx.alternativeNumberIndex(_ctx.contact.phoneNumbers)].extension
                                ,
                    "onUpdate:extension": _cache[15] || (_cache[15] = ($event: any) => ((
                                    _ctx.contact.phoneNumbers[_ctx.alternativeNumberIndex(_ctx.contact.phoneNumbers)].extension
                                ) = $event)),
                    type: _ctx.secondaryType,
                    "onUpdate:type": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.secondaryType) = $event)),
                    country: 
                                    _ctx.contact.phoneNumbers[_ctx.alternativeNumberIndex(_ctx.contact.phoneNumbers)].country
                                ,
                    "onUpdate:country": _cache[17] || (_cache[17] = ($event: any) => ((
                                    _ctx.contact.phoneNumbers[_ctx.alternativeNumberIndex(_ctx.contact.phoneNumbers)].country
                                ) = $event)),
                    disabled: !_ctx.isEditable
                  }, null, 8 /* PROPS */, ["phone-type-options", "value", "extension", "type", "country", "disabled"]), [
                    [_directive_number_only]
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_47, _hoisted_49)), [
                    [_directive_tooltip, {
                                    title: _ctx.contact.hasFamilyPortalAccess
                                        ? 'Email address is required to grant access to Family Portal.'
                                        : ''
                                }]
                  ]),
                  (_ctx.contact.hasFamilyPortalAccess)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, "*"))
                    : _createCommentVNode("v-if", true),
                  _withDirectives(_createElementVNode("input", {
                    name: "auth-contact-email",
                    class: "form-control",
                    maxlength: "50",
                    type: "text",
                    placeholder: "Enter Email",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.contact.email) = $event)),
                    disabled: !_ctx.isEditable
                  }, null, 8 /* PROPS */, _hoisted_51), [
                    [_vModelText, _ctx.contact.email]
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createVNode(_component_TagsInput, {
                    placeholder: "Select Race",
                    "aria-autocomplete": "off",
                    "open-on-focus": true,
                    data: _ctx.Races,
                    tags: _ctx.selectedRaces,
                    onUpdateTags: _ctx.updateSelectedRaces,
                    disabled: _ctx.isRacesDeclined
                  }, null, 8 /* PROPS */, ["data", "tags", "onUpdateTags", "disabled"]),
                  _createElementVNode("div", _hoisted_54, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      id: "decline-race",
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.isRacesDeclined) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, _ctx.isRacesDeclined]
                    ]),
                    _hoisted_55
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    name: "ethnicityPalliative",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.contact.ethnicityOnly) = $event)),
                    disabled: _ctx.isEthnicityDeclined
                  }, [
                    _hoisted_59,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Ethnicity, ([key, value]) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: value.value,
                        key: key
                      }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_60))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 8 /* PROPS */, _hoisted_58), [
                    [_vModelSelect, _ctx.contact.ethnicityOnly]
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      id: "decline-ethnicity",
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.isEthnicityDeclined) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, _ctx.isEthnicityDeclined]
                    ]),
                    _hoisted_62
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: `contact-emergency-${_ctx.contact.contactOrder}`,
                      class: "form-check-input au-target",
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.contact.isEmergencyContact) = $event)),
                      disabled: !_ctx.isEditable
                    }, null, 8 /* PROPS */, _hoisted_65), [
                      [_vModelCheckbox, _ctx.contact.isEmergencyContact]
                    ]),
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: `contact-emergency-${_ctx.contact.contactOrder}`
                    }, _hoisted_68, 8 /* PROPS */, _hoisted_66)
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: `contact-primary-bereaved-${_ctx.contact.contactOrder}`,
                      class: "form-check-input au-target",
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.contact.isBereavedContact) = $event)),
                      disabled: !_ctx.isEditable
                    }, null, 8 /* PROPS */, _hoisted_70), [
                      [_vModelCheckbox, _ctx.contact.isBereavedContact]
                    ]),
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: `contact-primary-bereaved-${_ctx.contact.contactOrder}`
                    }, _hoisted_73, 8 /* PROPS */, _hoisted_71)
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: `contact-family-portal-${_ctx.contact.contactOrder}`,
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.contact.hasFamilyPortalAccess) = $event)),
                      disabled: !_ctx.isEditable
                    }, null, 8 /* PROPS */, _hoisted_75), [
                      [_vModelCheckbox, _ctx.contact.hasFamilyPortalAccess]
                    ]),
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: `contact-family-portal-${_ctx.contact.contactOrder}`
                    }, _hoisted_78, 8 /* PROPS */, _hoisted_76)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_79, _hoisted_82))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}